export enum ZendeskTagsType {
    CustomerOnHold = 'ria_product_customer_on_hold',
    RiaApp = 'ria_money_transfer'
}


export enum ZendeskModalReasonsTags {
  MODIFY_RECIPIENT_ERROR = 'modify_recipient_error',
  MODIFY_RECIPIENT_NAME_ERROR = 'modify_recipient_name_error',
  STAGED_TRANSACTION_BARCODE_MISSING = 'staged_transaction_barcode_missing',
  EDIT_RECIPIENT_ERROR = 'edit_recipient_error',
  ADD_RECIPIENT_ERROR = 'add_recipient_error',
  REGISTRATION_INVALID_URL = 'registration_invalid_url',
  REGISTRATION_MAX_EKYC_ATTEMPTS = 'registration_max_ekyc_attempts',
  IDVERIFICATION_ACCOUNT_BLOCKED = 'idverification_account_blocked',
  WALLET_ACTIVATION_FAILED = 'wallet_activation_failed',
  CARD_BLOCKED_COMPLIANCE = 'card_blocked_compliance',
  CARD_LOCKED_SECURITY = 'card_locked_security',
  CARD_DAMAGED = 'card_damaged',
  CANCEL_ORDER_FAIL = 'cancel_order_fail',
  REGISTRATION_DEEPLINK_EXPIRED = 'registration_deeplink_expired',
  REGISTRATION_DUPLICATE_USER = 'registration_duplicate_user',
  DELETE_WALLET_ERROR = 'delete_wallet_error',
  PIN_RESET_IDENTITY_NOMATCH = 'pin_reset_identity_nomatch',
  BIOMETRIC_NO_MATCH = 'biometric_no_match',
  CARD_NOT_ARRIVED = 'card_not_arrived',
  CUSTOMER_REPORT_PROBLEM = 'customer_report_problem',
  DELETE_CARD_FAILED = 'delete_card_failed',
  CARD_COMPLIANCE_BLOCK = 'card_compliance_block',
  CVVPAGE_CONTACT_CARE = 'cvvpage_contact_care',
  REGISTRATION_ACCOUNT_BLOCKED = 'registration_account_blocked',
  IDVERIFICATION_FAILED_ATTEMPTS = 'idverification_failed_attempts',
  CUSTOMER_DISABLED_ACCOUNT_LOCKED = 'customer_disabled_account_locked',
  LITE_REGISTER_RET_VAL_BLOCKED = 'lite_register_ret_val_blocked',
  FRAUD_CHECK_FAILURE_EXCEPTION = 'fraud_check_failure_exception',
  BLOCKED_CANNOT_SEND = 'blocked_cannot_send',
  GENERAL_EXCEPTION = 'general_error_tags',
}

export enum ZendeskModalLocation {
  APP_SENDMONEY = 'app_sendmoney',
  APP_RECIPIENTDETAIL = 'app_recipientdetail',
  APP_IDVERIFICATION = 'app_idverification',
  APP_WALLET = 'app_wallet',
  APP_MYCARD = 'app_mycard',
  APP_REGISTRATION = 'app_registration',
  APP_SIGN_IN = 'app_sign_in',
}

export enum ZendeskGeneralInfo {
  RIA = "Ria app",
  AUTHENTICATED = "Authenticated",
  SUPPORT_GROUP_RIA_CARE = 'Ria - Care',
  SUPPORT_GROUP_RIA_PRODUCT_CHAT = 'Ria - Product Chat',
  CUSTOMER_TYPE = 'consumer',
}



// WEBPACK FOOTER //
// ./src/model/types/zendesk-tags-type.ts